module.exports = __webpack_public_path__ + "static/media/meAlt.27419e74.jpg";